<template>
  <v-row class="home flex-nowrap" no-gutters>
    <div class="left-column flex-grow-1 flex-shrink-1">
      <div class="navigation">
        <router-view name="navigation"></router-view>
      </div>
      <div class="main-ctn flex-shrink-1 flex-grow-1" v-if="initialized">
        <ControlBar v-if="currentRouteName !== 'config-global'" />
        <keep-alive>
          <router-view name="tab"></router-view>
        </keep-alive>
      </div>
    </div>

    <div v-if="isCampaignLoaded && isLandingPageConfigLoaded" class="preview-ctn flex-shrink-0 flex-grow-1 max-width-400" :class="{ 'full-screen': isPreviewFullScreen }">
      <auth-preview v-if="currentRouteName === 'config-auth-app-branding'" :fullscreen="isPreviewFullScreen" />
      <preview v-else mode="remote" :fullscreen="isPreviewFullScreen"></preview>
    </div>
  </v-row>
</template>

<script>
import Preview from '@/views/Preview'
import { mapGetters } from 'vuex'
import ControlBar from '@/components/ControlBar.vue'
import AuthAppBrandingPreview from '@/views/AuthAppBrandingPreview.vue'

export default {
  name: 'Home',
  components: {
    'auth-preview': AuthAppBrandingPreview,
    ControlBar,
    preview: Preview
  },
  computed: {
    ...mapGetters(['isCampaignLoaded', 'isLandingPageConfigLoaded', 'isPreviewFullScreen', 'initialized'])
  },
  data () {
    return {
      currentRouteName: this.$route.name
    }
  },
  watch: {
    '$route' (to, from) {
      this.currentRouteName = to.name
    }
  }
}

</script>

<style lang="sass">
@import "@/variables.sass"

.home
  height: 100%
  min-height: 0
  overflow: visible

.left-column
  display: flex
  flex-direction: column
  height: 100vh
  min-width: 0
  overflow: visible

.navigation
  z-index: 1
  flex: 0 0 auto
  height: auto !important

.main-ctn
  z-index: 999 !important
  background: white
  flex: 1 1 auto
  overflow-y: visible
  min-height: 0

.preview-ctn
  z-index: 1000
  border-left: 1px solid rgba(0,0,0,0.3)
  height: 100vh
  min-height: 0
  overflow-x: hidden
  overflow-y: auto
  -webkit-overflow-scrolling: touch
  padding-block: 12px

  // use grid to center when it fits
  display: none
  place-items: safe center

  // @include md
  &.max-width-400
    max-width: 400px
    width: 100%

  @include lg
    width: 345px
    display: grid

  @include xl
    width: 420px
    display: grid

  &.full-screen
    position: absolute
    inset: 0
    max-width: 100%
    background: white
    display: grid
    overflow-y: auto
    -webkit-overflow-scrolling: touch

</style>
